import { BreakpointObserver } from '@angular/cdk/layout';
import { inject, Service } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs/operators';
import { APP_CONFIG, IAppConfig } from '../app.config';

@Service()
export class ResponsiveDesignService {
  private readonly breakpointObserver = inject(BreakpointObserver);
  private readonly config = inject<IAppConfig>(APP_CONFIG);

  isSmallScreen$ = this.breakpointObserver
    .observe([this.config.smallScreenMediaQuery])
    .pipe(map((o) => o.matches));

  isSmallScreen = toSignal(this.isSmallScreen$, {
    initialValue: this.breakpointObserver.isMatched(this.config.smallScreenMediaQuery),
  });
}
